<template>
  <div class="head-item">
    <div class="head-click c-c van-hairline--bottom">
      <div class="bt van-hairline--surround radiusStyle" @click="down()">下架</div>
      <!--div v-if="mes.is_recommend == 1" style="width:auto;" class="grey bt van-hairline--surround" >店铺内刷新</div-->
      <div  style="width:auto;" class="bt van-hairline--surround radiusStyle" @click="refresh()">店铺内刷新</div>
      <div v-if="mes.is_recommend==1" style="width:auto;color:gray;" class="bt van-hairline--surround radiusStyle" @click="shopTop()">取消推荐</div>
      <div v-if="mes.is_recommend==0" style="width:auto;" class="bt van-hairline--surround radiusStyle" @click="noShopTop()">店铺内推荐</div>
    </div>
    <div class="main-mes van-hairline--bottom">
      <span
        class="t-l c-l f15"
        style="width:100%;white-space: break-spaces;"
        @click="toggleShow(mes.content)"
        v-toggleContent
      >{{ content }}</span>
    </div>
    <div class="c-c head-item-bottom" >
      <div class="c-l flex1 f11 one-hour">更新:{{ mes.published_time }}</div>
      <div class="flex1 c-c">
        <div class="man-pic" v-for="(item,index) in pics" :key="index" @click="previewPic(index)">
          <img :src="item" alt>
        </div>
      </div>
      <div v-if="showClose" style="position:fixed;bottom:100px;left:0px;width:100%;display:flex;justify-content: center;z-index:9999">
        <img @click="closeImg" style="width:30px;height:30px;" src="../assets/images/images/close.png" alt>
      </div>
      <div @click="warn()" class="c-end flex1 f11 one-hour"></div>
    </div>
    <!-- <DrawUp :class="showDrawUp == true? 'Sh': 'Hi'" @close="close"></DrawUp> -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect"/>
    <div class="pp">
      <van-image-preview v-model="showPreview" :images="images"></van-image-preview>
    </div>
  </div>
</template>

<script>
let instance;
import { ActionSheet } from 'vant';
import { Dialog } from "vant";
import { ImagePreview } from "vant";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
export default {
  name: "HeadItemThree",
  data() {
    return {
      showClose:false,
      showDrawUp: false,
      show: false,
      actions: [],
      showPreview: false,
      realSmallImages: [],
      realImages: [],
      images: []
    };
  },
  mounted() {},
  computed: {
    content() {
      return this.mes.content.slice(0, 110);
    },
    pics() {
      if (this.mes.thumbs.length != 0) {
        this.realImages = [];
        this.realSmallImages = [];
        for (let a = 0; a < this.mes.thumbs.length; a++) {
          this.realImages.push(this.mes.thumbs[a].path_url);
          this.realSmallImages.push(this.mes.thumbs[a].small_path_url);
        }
        this.images = this.realImages;
        return this.realSmallImages.slice(0, 3);
      } else {
        // return this.images;
      }
    }
  },
  methods: {
    closeImg(){
      this.showClose=false;
      if(instance){
        instance.close();
      }
      
    },
    //店铺内置顶
    shopTop(){
        postData(
            "/shop/stick",
            { good_id: this.mes.id,action:"0" },
            {
              headers: {
                token: localStorage.getItem("token")
              }
            }
          ).then(res => {
            this.$toast("取消成功");
            setTimeout(() => {
              this.$emit("reGetList");
            }, 1000);
          });
    },
    noShopTop(){
        postData(
            "/shop/stick",
            { good_id: this.mes.id,action:"1" },
            {
              headers: {
                token: localStorage.getItem("token")
              }
            }
          ).then(res => {
            this.$toast("推荐成功");
            setTimeout(() => {
              this.$emit("reGetList");
            }, 1000);
          });
    },
    previewPic(index) {
      this.showClose=true;
      instance =ImagePreview({
        images:this.images,
        asyncClose: true,
        startPosition:index
      });
    },
    onSelect(item) {
      // 点击选项时默认不会关闭菜单，可以手动关闭
      this.show = false;
      // Toast(item.name);
    },
    getList() {
      getData("/recommend-lists", {}).then(res => {});
    },
    toggleShow(index) {},
    warn() {
      this.show = true;
    },
    close() {
      this.showDrawUp = false;
    },
    down() {
      Dialog.confirm({
        // title: "下架",
        message: "确定下架吗？"
      })
        .then(() => {
          // on confirm
          postData(
            "/user/ban-good",
            { good_id: this.mes.id },
            {
              headers: {
                token: localStorage.getItem("token")
              }
            }
          ).then(res => {
            this.$toast("下架成功");
            setTimeout(() => {
              this.$emit("reGetList");
            }, 1000);
          });
        })
        .catch(() => {
          // on cancel
        });
      return;
    },
    refresh() {
        Dialog.confirm({
          message: "确定刷新吗？"
        }).then(() => {
            postData(
              "/user/refresh-good",
              { good_id: this.mes.id },
            ).then(res => {
              // let rest = res.data.total - res.data.used;
              // this.$toast(`刷新成功，本月剩余${ rest }`);
              setTimeout(() => {
                this.$emit("reGetList");
              }, 1000);
            }).catch(err=> {
              //this.$toast('刷新次数已用完');
            });
          })
          .catch(() => {

          });
    }
  },
  props: ["mes"],
  beforeDestroy() {
    this.closeImg();
  }
};
</script>

<style scoped>
.head-click {
  height: 35px;
}
.head-click .bt {
  width: 61px;
  height: 23px;
  font-size: 15px;
  margin-left: 7px;
  color: rgb(77, 77, 77);
  border-radius: 5px;
}
.head-item {
  width: 100%;
  /* height:343px; */
  background: #fff;
  margin-top: 3px;
  padding: 8px 12px 0px 16px;
  margin-top: 7px;
  box-sizing: border-box;
  border-radius: 5px;
}
.head-item-top {
  width: 100%;
  margin-top: 10px;
}
.phone {
  width: 20px;
  height: 20px;
}
.man-pic {
  width: 34px;
  height: 34px;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}
.man-pic img {
  width: auto !important;
  height: auto !important;
  max-width: 3rem;
  min-height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin:auto;
}
.head-item-bottom {
  height: 45px;
}
.main-mes {
  font-size: 12px;
  color: rgb(51, 51, 51);
  padding: 13px 0 12px 0;
}
.one-hour {
  color: rgb(143, 143, 143);
}
.main-pic {
  width: 29px;
  height: 29px;
}
.main-tag {
  margin-left: 4px;
}
.t128 {
  color: rgb(128, 128, 128);
  margin-top: 3px;
  width: 7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag-small div {
  width: 13px;
  height: 13px;
  margin-right: 3px;
}
.Sh {
  display: block;
}
.Hi {
  display: none;
}
.radiusStyle {
  border-radius: 10px;
  border: 1px solid #bdbdbd;
  padding: 0px 2px;
}
</style>
